<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Action Type</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="action_types.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="action_types.description"
                v-validate="'required'"
                data-vv-as="ActionTypes Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <DataGrid :context="'ActionTypeOutcomeOption'" 
            ref="actionTypes"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleActionTypeManagement from "@/store/action-type-management/moduleActionTypeManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      companySearchComponentKey: 0,
      please_choose_options: null,
      columnDefs: [
        {
          headerName: "Name",
          flex: 1,
          field: "name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Description",
          field: "description",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      allActionTypes: [],
      abilities: null,
      existing_list_values: [],
      existing_action_types_list: [],
      action_types: {
        name: null,
        description: null
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleActionTypeManagement,
    DataGrid,
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleActionTypeManagement.isRegistered) {
      this.$store.registerModule(
        "ActionTypesManagement",
        moduleActionTypeManagement
      );
      moduleActionTypeManagement.isRegistered = true;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("ActionTypesManagement/getAllActionTypes", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.actionTypes.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.actionTypes.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addActionTypes();
        }
      });
    },
    addActionTypes() {
      this.$store
        .dispatch("ActionTypesManagement/addActionTypes", this.action_types)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Action Types Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "ActionTypes Added",
              text: "The action types was added successfully"
            });
            this.$router.go(0);
            // this.$router.push({ path: "/action_types" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
